module.exports = __webpack_public_path__ + "static/media/contact.1a304bcd.jpg";